import numeral from 'numeral';

import { DEFAULT_PLACEHOLDER } from 'core/constants';

const DEFAULT_PERCENTAGE_FORMAT = '0,0.00%';

export const getPercentage = (
  value?: number | string,
  customOptions: {
    format?: string;
    placeholder?: string;
    isRawPercentage?: boolean;
  } = {}
) => {
  const options = {
    format: DEFAULT_PERCENTAGE_FORMAT,
    placeholder: DEFAULT_PLACEHOLDER,
    isRawPercentage: false,
    ...customOptions,
  };

  if (!value && value !== 0) {
    return options.placeholder;
  }

  const numericValue = Number(value);

  const adjustedValue = options.isRawPercentage ? numericValue / 100 : numericValue;

  return numeral(adjustedValue).format(options.format);
};

export const getAbbreviatedNumber = (
  value?: number,
  customOptions: {
    placeholder?: string;
  } = {}
) => {
  const options = {
    placeholder: DEFAULT_PLACEHOLDER,
    ...customOptions,
  };

  if (value === undefined || value === null) {
    return options.placeholder;
  }

  if (Math.abs(value) >= 1000) {
    return numeral(value).format('0.0a').toUpperCase();
  }

  return numeral(value).format('0,0');
};
